export enum PaymentMethods {
    paysafecard = 'paysafecard',
    google_pay = 'google_pay',
    apple_pay = 'apple_pay',
    paypal_vault = 'paypal_vault',
    flexcard = 'flexcard',
}
